<div class="container-wrapper">
  <h2 matDialogTitle>Add Existing User</h2>

  <mat-dialog-content>

    <div class="loading-wrapper" *ngIf="loading" style="padding: 2rem 0;">
      <mat-spinner diameter="36"></mat-spinner>
    </div>

    <div *ngIf="!loading">
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Select user</mat-label>
        <mat-icon matPrefix>person_search</mat-icon>
        <mat-select [(ngModel)]="selectedUserId" (ngModelChange)="onUserChange()">
          <mat-option *ngFor="let u of availableUsers" [value]="u.usr_id">
            {{ u.usr_name }} — {{ u.usr_mail }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="availableUsers.length === 0" style="opacity:0.5; font-size:0.85rem; margin-bottom: 1rem;">
        All active users are already in this organization.
      </div>

      <div>
        <div *ngFor="let cat of permissionCategories" style="margin-bottom: 0.5rem;">
          <div style="font-size: 0.68rem; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; opacity: 0.4; margin-bottom: 0.35rem;">
            {{ cat }}
          </div>
          <div class="invite-perms-grid">
            <div *ngFor="let perm of getPermsByCategory(cat)" class="perm-chip"
              [class.perm-chip--selected]="selectedPermissionIds.has(perm.id)"
              (click)="togglePermission(perm.id)">
              <mat-icon class="perm-chip__icon">
                {{ selectedPermissionIds.has(perm.id) ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              {{ perm.label }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button (click)="onClose()" [disabled]="saving">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirm()"
      [disabled]="!selectedUserId || selectedPermissionIds.size === 0 || saving || loading">
      <mat-spinner *ngIf="saving" diameter="18" style="display:inline-flex; margin-right:6px;"></mat-spinner>
      <mat-icon *ngIf="!saving">person_add</mat-icon>
      {{ saving ? 'Adding…' : 'Add to ' + data.org.org_name }}
    </button>
  </mat-dialog-actions>
</div>